import React, { useState, useEffect } from 'react';
import './App.scss';
import Select from './components/Select';
import Total from './components/Total';
import ButtonGroup from './components/ButtonGroup';
import { therapistList, nutritionistList, paymentGroup, mbList } from './data';

const App = () => {
  
  const [therapist, setTherapist] = useState();
  const [nutritionist, setNutritionist] = useState();
  const [payment, setPayment] = useState();
  const [secondList, setSecondList] = useState(nutritionistList);
  const [secondLabel, setSecondLabel] = useState('Nutritionist or Dietitian');

  useEffect(() => {
    let isMB = window.location.pathname.includes('metabolic-balance-plus');
    if(isMB) {
      setSecondList(mbList);
      setSecondLabel('Programme');
    } 
  }, []);

  return (
    <div className="price-calc bg-secondary-lightest p-3 text-secondary">
      <h3 className="text-uppercase mt-0">Calculate Programme Cost</h3>
      <Select
        value={therapist} onChange={(e) => setTherapist(JSON.parse(e.target.value))}
        options={therapistList} id="calcTherapist" label="Therapist"
      />
      <Select
        value={nutritionist} onChange={(e) => setNutritionist(JSON.parse(e.target.value))}
        options={secondList} id="calcNutritionist" label={secondLabel}
      />
      <ButtonGroup 
        label="Select payment" title="Payment option"
        onClick={setPayment} options={paymentGroup} selected={payment}
      />
      <hr />
      {therapist && nutritionist && payment ? 
        <Total therapist={therapist} nutritionist={nutritionist} payment={payment} />
      :
        <div className="alert alert-info small">To show the total cost, please select a therapist and nutritionist or dietitian of your choice. Then select the prefered payment option.</div>
      }
    </div>
  );
}

export default App;
